export const roundWithPrecision = (value: number, precision: number) => {
  var multiplier = Math.pow(10, precision);
  return Math.floor(value * multiplier + 0.49)/ multiplier;
};